import { DEFAULT_RUNNING_SEGMENT } from "./constants";

const segment = (overrides = {}) => ({
    ...DEFAULT_RUNNING_SEGMENT,
    ...overrides,
});

const block = ({ name, blockType = "main", repeat = 1, restBetweenRepeats = "", sets = [] }) => ({
    name,
    workoutType: "running",
    blockType,
    repeat,
    restBetweenRepeats,
    sets,
});

export const RUNNING_SESSION_GROUPS = [
    { value: "base", label: "Base" },
    { value: "interval", label: "Intervalados" },
    { value: "threshold", label: "Limiar/Tempo" },
    { value: "long_run", label: "Longões" },
    { value: "hill", label: "Subidas" },
    { value: "return", label: "Retorno" },
    { value: "club", label: "Clube" },
];

export const RUNNING_SESSION_LIBRARY = [
    {
        id: "run_6x400_5k",
        name: "6x400m ritmo 5K",
        group: "interval",
        sessionType: "short_intervals",
        objective: "5K",
        level: "Intermediário",
        estimatedDistanceKm: 7,
        estimatedDurationMin: 55,
        tags: ["pista", "5k", "tiros"],
        blocks: [
            block({
                name: "Aquecimento",
                blockType: "warmup",
                sets: [
                    segment({ segmentType: "warmup", label: "Trote leve", durationType: "distance", distance: 2, effortZone: "z2", targetType: "effort", notes: "Finalizar com mobilidade rápida." }),
                    segment({ segmentType: "stride", label: "Strides", reps: 4, durationType: "time", duration: 20, targetType: "effort", effortZone: "z4", restAfter: "40s caminhando" }),
                ],
            }),
            block({
                name: "Principal",
                blockType: "intervals",
                repeat: 6,
                restBetweenRepeats: "200m trote ou 90s",
                sets: [
                    segment({ segmentType: "interval", label: "400m forte", durationType: "distance", distance: 400, distanceUnit: "m", targetType: "pace", effortZone: "z5", notes: "Ritmo de prova de 5K." }),
                    segment({ segmentType: "recovery", label: "Recuperação", durationType: "distance", distance: 200, distanceUnit: "m", targetType: "effort", effortZone: "z1" }),
                ],
            }),
            block({
                name: "Desaquecimento",
                blockType: "cooldown",
                sets: [segment({ segmentType: "cooldown", label: "Soltar", durationType: "distance", distance: 1, effortZone: "z1", targetType: "effort" })],
            }),
        ],
    },
    {
        id: "run_5x1k_10k",
        name: "5x1km ritmo 10K",
        group: "interval",
        sessionType: "long_intervals",
        objective: "10K",
        level: "Intermediário",
        estimatedDistanceKm: 9,
        estimatedDurationMin: 65,
        tags: ["10k", "pista", "rua"],
        blocks: [
            block({ name: "Aquecimento", blockType: "warmup", sets: [segment({ segmentType: "warmup", label: "Trote leve", distance: 2, effortZone: "z2", targetType: "effort" })] }),
            block({
                name: "Principal",
                blockType: "intervals",
                repeat: 5,
                restBetweenRepeats: "2min trote",
                sets: [
                    segment({ segmentType: "interval", label: "1km ritmo 10K", distance: 1, targetType: "pace", effortZone: "z4" }),
                    segment({ segmentType: "recovery", label: "Recuperação", durationType: "time", duration: 2, targetType: "effort", effortZone: "z1" }),
                ],
            }),
            block({ name: "Desaquecimento", blockType: "cooldown", sets: [segment({ segmentType: "cooldown", label: "Soltar", distance: 2, effortZone: "z1", targetType: "effort" })] }),
        ],
    },
    {
        id: "run_fartlek_10x1",
        name: "Fartlek 10x1min",
        group: "threshold",
        sessionType: "fartlek",
        objective: "Base",
        level: "Todos",
        estimatedDistanceKm: 6,
        estimatedDurationMin: 45,
        tags: ["fartlek", "grupo", "parque"],
        blocks: [
            block({ name: "Aquecimento", blockType: "warmup", sets: [segment({ segmentType: "warmup", label: "Trote leve", durationType: "time", duration: 12, targetType: "effort", effortZone: "z2" })] }),
            block({
                name: "Principal",
                blockType: "main",
                repeat: 10,
                restBetweenRepeats: "1min leve",
                sets: [
                    segment({ segmentType: "run", label: "1min forte", durationType: "time", duration: 1, targetType: "effort", effortZone: "z4" }),
                    segment({ segmentType: "recovery", label: "1min leve", durationType: "time", duration: 1, targetType: "effort", effortZone: "z1" }),
                ],
            }),
            block({ name: "Desaquecimento", blockType: "cooldown", sets: [segment({ segmentType: "cooldown", label: "Soltar", durationType: "time", duration: 10, targetType: "effort", effortZone: "z1" })] }),
        ],
    },
    {
        id: "run_long_z2",
        name: "Longão Z2",
        group: "long_run",
        sessionType: "long_run",
        objective: "Meia maratona",
        level: "Todos",
        estimatedDistanceKm: 14,
        estimatedDurationMin: 90,
        tags: ["longao", "z2", "base"],
        blocks: [
            block({
                name: "Longão",
                blockType: "main",
                sets: [
                    segment({ segmentType: "run", label: "Ritmo confortável", distance: 14, targetType: "effort", effortZone: "z2", notes: "Conversável, sem acelerar no final." }),
                ],
            }),
        ],
    },
    {
        id: "run_hill_10x30",
        name: "Subida 10x30s",
        group: "hill",
        sessionType: "hill",
        objective: "Força específica",
        level: "Intermediário",
        estimatedDistanceKm: 5,
        estimatedDurationMin: 45,
        tags: ["subida", "forca", "tecnica"],
        blocks: [
            block({ name: "Aquecimento", blockType: "warmup", sets: [segment({ segmentType: "warmup", label: "Trote leve", durationType: "time", duration: 15, effortZone: "z2", targetType: "effort" })] }),
            block({
                name: "Principal",
                blockType: "intervals",
                repeat: 10,
                restBetweenRepeats: "Volta caminhando/trotando",
                sets: [
                    segment({ segmentType: "hill", label: "30s subida forte", durationType: "time", duration: 0.5, targetType: "effort", effortZone: "z5", terrain: "hill" }),
                    segment({ segmentType: "recovery", label: "Retorno", durationType: "open", targetType: "effort", effortZone: "z1", terrain: "hill" }),
                ],
            }),
        ],
    },
    {
        id: "run_walk_return",
        name: "Retorno 6x3min/2min",
        group: "return",
        sessionType: "walk_run",
        objective: "Retorno",
        level: "Iniciante",
        estimatedDistanceKm: 4,
        estimatedDurationMin: 40,
        tags: ["retorno", "iniciante", "caminhada"],
        blocks: [
            block({
                name: "Principal",
                blockType: "main",
                repeat: 6,
                restBetweenRepeats: "2min caminhada",
                sets: [
                    segment({ segmentType: "run", label: "3min trote", durationType: "time", duration: 3, targetType: "effort", effortZone: "z2" }),
                    segment({ segmentType: "walk", label: "2min caminhada", durationType: "time", duration: 2, targetType: "effort", effortZone: "z1" }),
                ],
            }),
        ],
    },
];
